import snackModal, { SnackModalOption } from '@/tools/snack-modal'

interface ErrorDialogOption {
  title?: SnackModalOption['header']
  msg: SnackModalOption['body']
}

/**
 * エラーダイアログを表示する
 * あまり発生しないものでエラータイトルとメッセージを考えるのは粒度がバラバラになりやすそうなので、
 * 標準で「エラーが発生しました。」と表示しつつメッセージのみ指定する形で使う
 *
 * ex) showErrorDialog({msg: 再度メール認証を行ってください。})
 * title: エラーが発生しました, msg: 再度メール認証を行ってください。
 */
const showErrorDialog = (option: ErrorDialogOption): void => {
  snackModal({
    header: option.title || 'エラーが発生しました。',
    body: option.msg,
  })
}

export default showErrorDialog
